import Button from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface SettingsFooterProps {
  onSave?: () => void;
  onCancel?: () => void;
  saveText?: string;
  cancelText?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

export const SettingsFooter = ({
  onSave,
  onCancel,
  saveText,
  cancelText,
  isLoading = false,
  disabled = false,
}: SettingsFooterProps) => {
  const { t } = useTranslation();

  const handleSave = () => {
    if (onSave && !disabled && !isLoading) {
      onSave();
    }
  };

  const handleCancel = () => {
    if (onCancel && !isLoading) {
      onCancel();
    }
  };

  return (
    <div className="pt-5 border-t border-border-secondary dark:border-gray-600">
      <div className="flex flex-col-reverse sm:flex-row items-stretch sm:items-center sm:justify-end gap-3">
        <button
          onClick={handleCancel}
          disabled={disabled || isLoading}
          className="w-full sm:w-auto px-3.5 py-2.5 rounded-lg bg-white dark:bg-gray-700 border border-border-primary dark:border-gray-500 text-text-secondary dark:text-gray-200 text-sm font-semibold hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {cancelText || t("settings.profile.cancel")}
        </button>
        <Button
          variant="darkPrimary"
          onClick={handleSave}
          disabled={disabled || isLoading}
          className="w-full sm:w-auto justify-center px-4 py-2.5 rounded-lg bg-gray-900 dark:bg-gray-800 text-white text-sm font-medium hover:bg-teal-600 dark:hover:bg-teal-700 transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        >
          {isLoading && (
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          )}
          {saveText || t("settings.profile.saveChanges")}
        </Button>
      </div>
    </div>
  );
};
